module.exports = __webpack_public_path__ + "static/media/pl-or-1.6c1ac2cd.jpg";